var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { registerDashboard } from '../registryCore';
import { bool, createWidgetGroup, getState, num, setState, str, } from '../helpers';
import { syntheticEvent } from '../../components/helpers';
import { getActiveDashboard } from '../theme';
import { installChartRebuild } from '../charts/core/refresh';
function asStringRows(rows) {
    if (!Array.isArray(rows))
        return [];
    return rows.map(function (row) {
        return Array.isArray(row) ? row.map(function (c) { return String(c !== null && c !== void 0 ? c : ''); }) : [String(row !== null && row !== void 0 ? row : '')];
    });
}
/** Filter rows where any cell contains the query (case-insensitive). */
export function filterTableRows(rows, query) {
    var q = query.trim().toLowerCase();
    if (!q)
        return rows;
    return rows.filter(function (row) { return row.some(function (cell) { return cell.toLowerCase().includes(q); }); });
}
registerDashboard('dataTable', function (props, app) {
    var group = createWidgetGroup(app, 'dataTable', props, { focusable: true, role: 'grid' });
    installChartRebuild(group, app, buildDataTable);
    return group;
});
function buildDataTable(group, app, props) {
    var _a, _b;
    var columns = (_a = props.columns) !== null && _a !== void 0 ? _a : ['Name', 'Value'];
    var allRows = asStringRows((_b = props.rows) !== null && _b !== void 0 ? _b : [
        ['Alpha', '42'],
        ['Beta', '18'],
        ['Gamma', '27'],
    ]);
    var showSearch = bool(props, 'showSearch', false);
    var search = str(props, 'search', str(props, 'searchQuery', ''));
    var striped = bool(props, 'striped', true);
    var sortable = bool(props, 'sortable', false);
    var sortColumn = num(props, 'sortColumn', -1);
    var sortDirection = str(props, 'sortDirection', 'asc') === 'desc' ? 'desc' : 'asc';
    var selectedRow = num(props, 'selectedRow', -1);
    var colW = num(props, 'colWidth', 0);
    var width = num(props, 'width', Math.max(240, columns.length * 100));
    var rowH = Math.max(28, num(props, 'rowHeight', 34));
    var searchH = showSearch ? 36 : 0;
    var pad = 1;
    var theme = getActiveDashboard();
    var cellW = colW > 0 ? colW : width / Math.max(columns.length, 1);
    var rows = filterTableRows(allRows, search);
    if (sortable && sortColumn >= 0 && sortColumn < columns.length) {
        rows = __spreadArray([], __read(rows), false).sort(function (a, b) {
            var _a, _b;
            var cmp = ((_a = a[sortColumn]) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b[sortColumn]) !== null && _b !== void 0 ? _b : '', undefined, {
                numeric: true,
                sensitivity: 'base',
            });
            return sortDirection === 'asc' ? cmp : -cmp;
        });
    }
    var tableH = searchH + rowH * (rows.length + 1);
    var height = num(props, 'height', 0) > 0 ? num(props, 'height', tableH) : tableH;
    group.metadata.chartWidth = width;
    group.metadata.chartHeight = height;
    group.add(app.roundedRect({
        width: width,
        height: height,
        cornerRadius: 8,
        fill: theme.chartBg,
        stroke: theme.panelStroke,
        strokeWidth: 1,
        listening: false,
    }));
    if (showSearch) {
        var focused = bool(props, 'searchFocused', false);
        group.add(app.roundedRect({
            x: 8,
            y: 6,
            width: width - 16,
            height: 24,
            cornerRadius: 6,
            fill: theme.chartPlot,
            stroke: focused ? theme.primary : theme.panelStroke,
            strokeWidth: focused ? 1.5 : 1,
            listening: true,
        }));
        group.add(app.text({
            text: search || 'Search…',
            x: 16,
            y: 10,
            fontSize: theme.fontSizeSm,
            fill: search ? theme.text : theme.textMuted,
            listening: false,
        }));
        var searchHit = app.rect({
            x: 8,
            y: 6,
            width: width - 16,
            height: 24,
            fill: 'rgba(0,0,0,0.001)',
            listening: true,
        });
        searchHit.on('click', function () {
            var _a, _b;
            setState(group, { searchFocused: true });
            (_b = (_a = group.metadata).chartRebuild) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
        group.add(searchHit);
        if (!group.metadata._dataTableKeyBound) {
            group.metadata._dataTableKeyBound = true;
            var onKey = function (e) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var st = group.metadata.widgetState;
                if (!(st === null || st === void 0 ? void 0 : st.showSearch) || !st.searchFocused)
                    return;
                if (e.key === 'Escape') {
                    setState(group, { searchFocused: false });
                    (_b = (_a = group.metadata).chartRebuild) === null || _b === void 0 ? void 0 : _b.call(_a);
                    return;
                }
                if (e.key === 'Backspace') {
                    e.preventDefault();
                    var next = String((_c = st.search) !== null && _c !== void 0 ? _c : '').slice(0, -1);
                    setState(group, { search: next, searchQuery: next });
                    (_e = (_d = group.metadata).chartRebuild) === null || _e === void 0 ? void 0 : _e.call(_d);
                    return;
                }
                if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
                    e.preventDefault();
                    var next = String((_f = st.search) !== null && _f !== void 0 ? _f : '') + e.key;
                    setState(group, { search: next, searchQuery: next });
                    (_h = (_g = group.metadata).chartRebuild) === null || _h === void 0 ? void 0 : _h.call(_g);
                }
            };
            var root = typeof document !== 'undefined' ? document : null;
            root === null || root === void 0 ? void 0 : root.addEventListener('keydown', onKey);
            group.metadata._dataTableKeyHandler = onKey;
        }
    }
    var headerY = searchH;
    group.add(app.rect({
        x: pad,
        y: headerY,
        width: width - pad * 2,
        height: rowH,
        fill: theme.panel,
        listening: false,
    }));
    columns.forEach(function (col, ci) {
        var sorted = sortable && sortColumn === ci;
        var arrow = sorted ? (sortDirection === 'asc' ? ' ▲' : ' ▼') : sortable ? ' ⇅' : '';
        var th = app.group({
            x: ci * cellW,
            y: headerY,
            listening: sortable,
            metadata: { colIndex: ci },
        });
        th.add(app.text({
            text: col.toUpperCase() + arrow,
            x: 12,
            y: Math.max(8, (rowH - theme.fontSizeSm) / 2),
            fontSize: theme.fontSizeSm,
            fontWeight: 'bold',
            fill: sorted ? theme.primary : theme.textMuted,
            listening: false,
        }));
        if (sortable) {
            th.on('click', function () {
                var _a, _b;
                var prev = num(getState(group), 'sortColumn', -1);
                var prevDir = str(getState(group), 'sortDirection', 'asc');
                var nextDir = prev === ci && prevDir === 'asc' ? 'desc' : 'asc';
                setState(group, { sortColumn: ci, sortDirection: nextDir });
                (_b = (_a = group.metadata).chartRebuild) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
        }
        group.add(th);
    });
    rows.forEach(function (row, ri) {
        var rowY = headerY + (ri + 1) * rowH;
        var zebra = striped && ri % 2 === 1;
        var selected = ri === selectedRow;
        if (zebra || selected) {
            group.add(app.rect({
                x: pad,
                y: rowY,
                width: width - pad * 2,
                height: rowH,
                fill: selected ? theme.primary : theme.chartPlot,
                opacity: selected ? 0.25 : 1,
                listening: false,
            }));
        }
        if (selected) {
            group.add(app.rect({
                x: pad,
                y: rowY,
                width: 3,
                height: rowH,
                fill: theme.primary,
                listening: false,
            }));
        }
        var rowGroup = app.group({
            x: 0,
            y: rowY,
            listening: true,
            metadata: { rowIndex: ri },
        });
        row.forEach(function (cell, ci) {
            rowGroup.add(app.text({
                text: cell,
                x: ci * cellW + 12,
                y: Math.max(8, (rowH - theme.fontSize) / 2),
                fontSize: theme.fontSize,
                fill: selected ? theme.primary : theme.text,
                listening: false,
            }));
        });
        rowGroup.on('click', function () {
            var _a, _b;
            setState(group, { selectedRow: ri, searchFocused: false });
            group.emit('select', syntheticEvent('select', group, { index: ri, row: row }));
            (_b = (_a = group.metadata).chartRebuild) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
        group.add(rowGroup);
    });
    setState(group, {
        columns: columns,
        rows: allRows,
        width: width,
        height: height,
        colWidth: cellW,
        rowHeight: rowH,
        striped: striped,
        showSearch: showSearch,
        search: search,
        searchQuery: search,
        searchFocused: bool(props, 'searchFocused', false),
        sortable: sortable,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        selectedRow: selectedRow,
        stickyHeader: bool(props, 'stickyHeader', true),
        maxHeight: num(props, 'maxHeight', 0),
    });
}
